export default __webpack_public_path__ + "static/media/Vector.32349a63.svg";